// ============================================================================
// TÌM KIẾM KHÔNG DẤU TIẾNG VIỆT CHO BỘ LỌC CỦA PRIMEREACT
//
// Vấn đề: PrimeReact tự bỏ dấu trước khi so khớp, nhưng hàm ObjectUtils.removeAccents
// của nó CHỈ xử lý dải Latin-1 (\xC0-\xFF) — vốn dành cho tiếng Pháp/Đức. Phần lớn ký
// tự tiếng Việt nằm NGOÀI dải đó nên không được bỏ dấu:
//   'ĐƠN HÀNG'        -> 'đơn hang'   (đ, ơ không đổi)  => gõ 'don hang' KHÔNG ra
//   'NGUYỄN VĂN A'    -> 'nguyễn văn a'                 => gõ 'nguyen van a' KHÔNG ra
//   'QUẢN TRỊ HỆ THỐNG' -> 'quản trị hệ thống'          => gõ 'quan tri' KHÔNG ra
// (Chỉ vài chữ như 'CÔNG TY', 'XE TÌM HÀNG' tình cờ đúng vì ô/ì nằm trong Latin-1.)
//
// Cách sửa: thay thẳng ObjectUtils.removeAccents bằng bản hỗ trợ đầy đủ tiếng Việt.
// FilterUtils gọi hàm này cho CẢ chuỗi người dùng gõ lẫn giá trị của từng option, nên
// một lần vá là mọi bộ lọc dùng chung: MultiSelect, Dropdown, AutoComplete, ListBox,
// DataTable filter... KHÔNG phải sửa từng chỗ gọi (dự án có hơn 30 file dùng MultiSelect).
// ============================================================================

/**
 * Bỏ dấu tiếng Việt.
 *
 * Dùng NFD để tách ký tự gốc khỏi dấu rồi xóa toàn bộ dấu tổ hợp (U+0300–U+036F) —
 * cách này phủ hết dấu thanh (huyền/sắc/hỏi/ngã/nặng) lẫn dấu phụ (mũ ˆ, trăng ˘,
 * móc ̛ của ơ/ư). Riêng đ/Đ là CHỮ CÁI riêng, không tách được bằng NFD nên xử lý tay.
 *
 * Chỉ bỏ dấu, KHÔNG đụng tới dấu câu hay khoảng trắng — khác với removeVietnameseTones
 * trong utilities/common.tsx (hàm đó còn xóa dấu câu, không hợp cho việc lọc mã như
 * `MCDH_123`).
 */
export const removeViAccents = (str: any): any => {
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .normalize('NFC');
};

/**
 * Vá ObjectUtils.removeAccents của PrimeReact. Gọi MỘT LẦN lúc khởi động app,
 * TRƯỚC khi render (xem index.tsx).
 */
export function patchPrimeReactViFilter(): void {
  try {
    // PrimeReact 4 không export ObjectUtils ra ngoài nên phải trỏ thẳng vào file.
    // Đây đúng là module mà FilterUtils require (`../utils/ObjectUtils`) nên vá được.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const objectUtilsModule = require('primereact/components/utils/ObjectUtils');
    const ObjectUtils = objectUtilsModule?.default || objectUtilsModule;
    if (!ObjectUtils || ObjectUtils.__viAccentsPatched) {
      return;
    }
    ObjectUtils.removeAccents = removeViAccents;
    ObjectUtils.__viAccentsPatched = true;
  } catch (e) {
    // Không chặn app khởi động nếu PrimeReact đổi cấu trúc thư mục ở bản sau —
    // bộ lọc chỉ quay về hành vi cũ (có dấu mới ra kết quả).
    console.warn('Không vá được bộ lọc không dấu của PrimeReact:', e);
  }
}
